import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import CheckboxActive from '../../icons/CheckboxActive';

// No idea why I can't import it from node_modules
import './pretty-checkbox.min.css';
import './checkbox.css';


const Checkbox = ({
  id,
  name,
  title,
  checked,
  disabled,
  uncontrollable,
  onToggle,
  className,
  CheckboxComponent,
}) => (
  <div className={classnames('pretty p-svg', className)} style={{ fontSize: '14px' }}>
    <input
      type="checkbox"
      id={id}
      name={name}
      onChange={onToggle}
      checked={uncontrollable ? undefined : checked}
      disabled={disabled}
    />
    <div className="state">
      <CheckboxComponent className="svg" />
      <label
        htmlFor={id}
        style={{
          color: '#504d4c',
          position: 'relative',
          paddingLeft: '4px',
        }}
      >
        {title}
      </label>
    </div>
  </div>
);

Checkbox.defaultProps = {
  title: '',
  checked: false,
  disabled: false,
  uncontrollable: false,
  className: null,
  CheckboxComponent: CheckboxActive,
  onToggle: () => {},
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  uncontrollable: PropTypes.bool,
  onToggle: PropTypes.func,
  className: PropTypes.string,
  CheckboxComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default Checkbox;
